import React from 'react';
import { Avatar, Box, Fab } from '@mui/material';
import { ChatBotIcon } from '@shared/custom-icons';
import { SystemStyleObject } from '@mui/system';

interface Props {
  onClick: () => void;
  sx?: SystemStyleObject;
}

export const ChatbotFab = React.forwardRef<HTMLDivElement, Props>(
  ({ onClick, sx, ...props }, ref) => (
    <Box
      ref={ref}
      border="2px solid"
      borderColor="primary.main"
      borderRadius="50%"
      sx={{
        zIndex: ({ zIndex }) => zIndex.modal + 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: 'background.paper',
        boxShadow: 'none',
        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        '&:hover': {
          transform: 'scale(1.1)',
          boxShadow: '0px 12px 32px rgba(0,0,0,0.3)',
        },
        ...sx,
      }}
      {...props}
    >
      <Fab onClick={onClick}>
        <Avatar
          sx={{
            width: 56,
            height: 56,
            bgcolor: 'background.paper',
          }}
        >
          <ChatBotIcon sx={{ width: 66, height: 66, color: 'primary.main', marginTop: '-5px' }} />
        </Avatar>
      </Fab>
    </Box>
  )
);
